import { fetchGraphql } from ".";
import { listAllContentQuery, listRecentContentQuery } from "../../graphql/queries";
import { ListAllContentQuery, ListAllContentQueryVariables, ListRecentContentQuery, ListRecentContentQueryVariables } from "../../graphql/types";

export type BackendContentItem = NonNullable<ListRecentContentQuery["self"]>["recent"][0];

export async function getRecentContent(maxStarred: number, maxUnstarred: number): Promise<ListRecentContentQuery | null> {
    const result = await fetchGraphql<ListRecentContentQuery, ListRecentContentQueryVariables>("ListRecentContent", listRecentContentQuery, { maxStarred, maxUnstarred }, true);
    return result.data ?? null;
}

export async function getAllContent(): Promise<ListAllContentQuery | null> {
    const result = await fetchGraphql<ListAllContentQuery, ListAllContentQueryVariables>("ListAllContent", listAllContentQuery, { }, true);
    return result.data ?? null;
}
